import { Paper, styled } from '@mui/material';
export const PaperStyled = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3),
    gap: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    // Styles of paper from Popover theme.
    borderRadius: 'var(--gp-radius-xl)',
    boxShadow: theme.shadows[11],
}));
